<div fxLayout="column" fxLayoutGap="10px" [formGroup]="form">
	<div fxLayout="row wrap" fxLayoutGap="10px grid">
		<mat-form-field fxFlex="calc(300px)">
			<input
				autocomplete="first-name"
				matInput
				placeholder="First Name"
				formControlName="firstName"
			/>
			<mat-error>Required</mat-error>
		</mat-form-field>
		<mat-form-field fxFlex="calc(300px)">
			<input
				autocomplete="last-name"
				matInput
				placeholder="Last Name"
				formControlName="lastName"
			/>
			<mat-error>Required</mat-error>
		</mat-form-field>
		<mat-form-field fxFlex="calc(300px)">
			<input
				autocomplete="contact-role"
				matInput
				placeholder="Role"
				formControlName="role"
			/>
		</mat-form-field>
	</div>
	<rpshared-primary-phone-number
		formControlName="phoneNumbers"
	></rpshared-primary-phone-number>
	<rpshared-primary-email-address 
		[emailRequired]="emailRequired"
		formControlName="emailAddresses"
	></rpshared-primary-email-address>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="form.invalid || getEmailControlInvalid || getPhoneControlInvalid"
			color="primary"
			[mat-dialog-close]="form"
		>
			Save
		</button>
	</div>
</div>
